var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6569 15.1569C13.7202 16.0935 11.7616 18.0521 10.4138 19.3999C9.63275 20.181 8.36768 20.1814 7.58663 19.4003C6.26234 18.076 4.34159 16.1553 3.34315 15.1569C0.218951 12.0327 0.218951 6.96734 3.34315 3.84315C6.46734 0.718951 11.5327 0.718951 14.6569 3.84315C17.781 6.96734 17.781 12.0327 14.6569 15.1569Z",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.5C12 11.1569 10.6569 12.5 9 12.5C7.34315 12.5 6 11.1569 6 9.5C6 7.84315 7.34315 6.5 9 6.5C10.6569 6.5 12 7.84315 12 9.5Z",
    stroke: "#94A3B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c2921d42a9f63e1f08b774466d8220a2.svg";
export { ForwardRef as ReactComponent };